import { TRANSPORT_BODYTYPE_ADDITIONALS } from "../constants/transport";
import { convertResponseToAddress } from '@/types/mapbox';

// Remove empty strings from address object
const cleanAddress = (address) => {
  if (!address || typeof address !== 'object') return address;
  const cleaned = { ...address };
  Object.keys(cleaned).forEach(key => {
    if (cleaned[key] === '') {
      delete cleaned[key];
    }
  });
  return cleaned;
};

export const initializeTransportFields = {
    available_from: "",
    available_to: "",
    carrying_capacity: "",
    conics: false,
    country_id: "",
    direct_contract: false,
    employee_ids: "",
    fuel_prepayment: false,
    gidrolift: false,
    height: "",
    length: "",
    loading_radius: "",
    notes: "",
    own_name: "",
    partial_load: false,
    payment_rate_type_id: "",
    payment_type_id: "",
    prepayment: "",
    registration_number: "",
    loading_address: null,
    unloading_address: null,
    trailer_registration_number: "",
    transport_bodytype_additionals_id: "",
    transport_bodytype_ids: [],
    transport_ids: "",
    transports_loading_types: "",
    unloading_radius: "",
    upload: false,
    volume: "",
    width: "",
    transport_technical_documents: undefined,
    route_distance_meters: null,
};

class ExchangeTransport {
    static initFormData(data) {
        const formData = { ...initializeTransportFields };
        for (let item in data) {
            if (item in initializeTransportFields) {
                if (data[item] !== null) {
                    formData[item] = data[item];
                } else if (!data[item]) {
                    formData[item] = initializeTransportFields[item];
                }
            }
        }
        if (data.transport_technical_documents) {
            formData.transport_technical_documents = data.transport_technical_documents;
        }
        if (formData.transports_loading_types?.length > 0) {
            formData.transports_loading_types = formData.transports_loading_types.map(
                (item) => item.loading_type?.id || item.id || item,
            );
        }
        // Convert transport_bodytypes array of objects to transport_bodytype_ids array of IDs
        if (data.transport_bodytypes?.length > 0) {
            formData.transport_bodytype_ids = data.transport_bodytypes.map(
                (item) => item.id || item,
            );
        }
        if (formData.transport_bodytype_additionals_id) {
            formData.transport_bodytype_additionals_id = String(
                formData.transport_bodytype_additionals_id,
            );
        }

        if (formData.loading_address) {
          formData.loading_address = convertResponseToAddress(formData.loading_address);
        }

        if (formData.unloading_address) {
          formData.unloading_address = convertResponseToAddress(formData.unloading_address);
        }

        formData.employee_ids = data.employees;

        return formData;
    }

    static formData(data) {
        const formData = {};
        for (let item in data) {
            if (item !== "transport_technical_documents" && item in initializeTransportFields) {
                formData[item] = data[item];
            }
        }
        formData.id = data.id;
        delete formData.transport_ids;

        if (formData.available_from) {
            const availableFrom = new Date(formData.available_from);
            availableFrom.setHours(0, 0, 0, 0);

            formData.available_from = availableFrom.toISOString();
        }
        if (formData.available_to) {
            const availableTo = new Date(formData.available_to);
            availableTo.setHours(23, 59, 59, 999);

            formData.available_to = availableTo.toISOString();
        }

        if (formData.loading_address) {
            formData.loading_address = formData.loading_address.value ? formData.loading_address.value : formData.loading_address;
            formData.loading_address = cleanAddress(formData.loading_address);
        }
        if (formData.unloading_address) {
            formData.unloading_address = formData.unloading_address.value ? formData.unloading_address.value : formData.unloading_address;
            formData.unloading_address = cleanAddress(formData.unloading_address);
        }

        if (formData.country_id) {
            formData.country_id = formData.country_id.value;
        } else {
            formData.country_id = [];
        }

        if (
            formData.transport_bodytype_additionals_id !== TRANSPORT_BODYTYPE_ADDITIONALS.COUPLING
        ) {
            formData.trailer_registration_number = "";
        } else if (
            formData.transport_bodytype_additionals_id === TRANSPORT_BODYTYPE_ADDITIONALS.COUPLING
        ) {
            formData.trailer_registration_number = data.trailer_registration_number;
        }

        formData.employee_ids =
            data.employee_ids && data.employee_ids.length > 0
                ? data.employee_ids.map((item) => item.value)
                : [];

        return formData;
    }
}

export default ExchangeTransport;
